import { onlyDigits } from "./only-digits";

export function isValidCPF(value: string): boolean {
	const cpf = onlyDigits(value);
	if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

	const checkDigit = (length: number) => {
		let sum = 0;
		for (let i = 0; i < length; i++) {
			sum += Number(cpf[i]) * (length + 1 - i);
		}
		const remainder = (sum * 10) % 11;
		return remainder === 10 ? 0 : remainder;
	};

	return checkDigit(9) === Number(cpf[9]) && checkDigit(10) === Number(cpf[10]);
}
